import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainNavigationComponent } from '@ace/ace';
import { AuthserviceService } from "@ace/ace";

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('@ace/ace').then((m) => m.LoginModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('@ace/ace').then(
        (m) => m.ForgotPasswordModule
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('@ace/ace').then(
        (m) => m.ResetPasswordModule
      ),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'main',
    component: MainNavigationComponent,
    children: [
      { path: '', redirectTo: 'landing-page', pathMatch: 'full' },
      {
        path: 'landing-page',
        loadChildren: () =>
          import('./layouts/landing-page-layout/landing-page-layout.module').then(
            (m) => m.LandingPageLayoutModule
          ),
      },
      {
        path: 'landing-page-layout',
        loadChildren: () =>
          import(
            './layouts/landing-page-layout/landing-page-layout.module'
          ).then((m) => m.LandingPageLayoutModule),
      },
      {
        path: 'master-management',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.MasterManagementV2Module
          ),
      },
      {
        path: 'master-management-v2',
        loadChildren: () =>
          import(
            '@ace/ace'
          ).then((m) => m.MasterManagementV2Module),
      },
 

            {
        path: 'user-logging',
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.UserLoggingModule,
          )
      },
      {
        path: 'inquiries',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.InquiriesModule
          ),
      },
      {
        path: 'alerts',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.AlertsModule),
      },
      /** To be modified later **/
      {
        path: 'landing-list/:moduleId',
        loadComponent: () =>
          import(
            '@ace/ace'
          ).then((m) => m.DynamicLandingListComponent),
      },
      {
        path: 'messaging',
        loadChildren: () =>
          import(
            './layouts/message/message.module'
          ).then((m) => m.MessageModule),
      },
      {
        path: 'learner-management',
        loadChildren: () =>
          import(
            './layouts/learner-management/learner-management.module'
          ).then((m) => m.LearnerManagementModule),
      },
      {
        path: 'child-reports',
        loadChildren: () =>
          import(
            './layouts/child-reports.module'
          ).then((m) => m.ChildReportsModule),
      },
      {
        path: 'child-feedbacks',
        loadChildren: () =>
          import(
            './layouts/child-feedbacks.module'
          ).then((m) => m.ChildFeedbacksModule),
      },
      {
        path: 'events',
        loadChildren: () =>
          import(
            './layouts/parent-events/parent-events.module'
          ).then((m) => m.ParentEventsModule),
      },
      {
        path: 'message',
        redirectTo: 'messaging',
        pathMatch: 'full',
      },
      {
        path: ':moduleId/form/:action',
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                '@ace/ace'
              ).then((m) => m.FormHandlingComponent),
          },
          {
            path: '',
            loadComponent: () =>
              import(
                '@ace/ace'
              ).then((m) => m.FormHandlingComponent),
          },
        ],
      },

      {
        path: 'case-details',
        loadComponent: () =>
          import('@ace/ace').then(
            (m) => m.CaseDetailsComponent
          ),
      },
      {
        path: 'casedetails',
        loadComponent: () =>
          import('@ace/ace').then(
            (m) => m.CaseDetailsComponent
          ),
      },

      {
        path: 'tasks',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.TasksModule),
      },
      {
        path: 'system-reports-v2',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.SystemReportsV2Module
          ),
      },
      {
        path: 'audit-trail',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.AuditTrailModule
          ),
      },
      {
        path: 'user-management',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.ConfigurationModule
          ),
      },
      {
        path: 'querybuilder',
        loadChildren: () =>
          import(
            '@ace/ace' // Adjust the path as necessary
          ).then((m) => m.QuerybuilderModule),
      },
      {
        path: 'data-integration',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.DataIntegrationModule
          ),
      },

         {
        path: 'smtp-configuration',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.SmtpConfigurationModule
          ),
      },
      

         {
        path: 'security',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.SecurityModule
          ),
      },
            {
        path: 'active-dir-management',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.ActiveDirManagementModule
          ),
          
      },
    ],
    canActivate: [AuthserviceService],
  },
  // { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



